export default __webpack_public_path__ + "static/assets/864a7c38fb36e648f1699c796b21c8d2.png";